var _defs, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _g, _circle24, _linearGradient, _circle25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeaderElipse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 180,
    viewBox: "0 0 1440 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ellipseClip"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 481,
    cy: -295,
    rx: 1611,
    ry: 465
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_959_271",
    x1: 240.5,
    y1: -236,
    x2: 1616,
    y2: 408.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15A0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522513,
    stopColor: "#199BD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02628C"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ellipseClip)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 481,
    cy: -295,
    rx: 1611,
    ry: 465,
    fill: "url(#paint0_linear_959_271)"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 170,
    viewBox: "0 0 1440 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180 -11.4058L199.859 -3.34718L182.957 9.83687L180 -11.4058Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202.305 -28.8042L222.163 -20.7456L205.261 -7.56157L202.305 -28.8042Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.61 -46.2026L244.468 -38.1441L227.566 -24.96L224.61 -46.2026Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M246.915 -63.6011L266.773 -55.5425L249.871 -42.3584L246.915 -63.6011Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.219 -80.9995L289.078 -72.9409L272.176 -59.7569L269.219 -80.9995Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M208.535 2.21976L228.394 10.2783L211.492 23.4624L208.535 2.21976Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230.84 -15.1787L250.699 -7.12009L233.797 6.06395L230.84 -15.1787Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M253.145 -32.5771L273.004 -24.5185L256.102 -11.3345L253.145 -32.5771Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M275.45 -49.9756L295.308 -41.917L278.406 -28.7329L275.45 -49.9756Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M237.071 15.8453L256.929 23.9039L240.027 37.0879L237.071 15.8453Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M259.376 -1.55316L279.234 6.50542L262.332 19.6895L259.376 -1.55316Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M281.68 -18.9516L301.539 -10.893L284.637 2.29104L281.68 -18.9516Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M265.606 29.4708L285.465 37.5294L268.563 50.7134L265.606 29.4708Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M287.911 12.0724L307.769 20.1309L290.867 33.315L287.911 12.0724Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M294.141 43.0963L314 51.1549L297.098 64.339L294.141 43.0963Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -6.2168,
    cy: 137.737,
    r: 6.73132,
    transform: "rotate(-45 -6.2168 137.737)",
    fill: "#FFE10C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.04492,
    cy: 123.475,
    r: 6.73132,
    transform: "rotate(-45 8.04492 123.475)",
    fill: "#FFE10C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3066,
    cy: 109.212,
    r: 6.73132,
    transform: "rotate(-45 22.3066 109.212)",
    fill: "#FFE10C"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5703,
    cy: 94.9492,
    r: 6.73132,
    transform: "rotate(-45 36.5703 94.9492)",
    fill: "#FFE10C"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.832,
    cy: 80.6865,
    r: 6.73132,
    transform: "rotate(-45 50.832 80.6865)",
    fill: "#FFE10C"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: -6.2168,
    cy: 166.263,
    r: 6.73132,
    transform: "rotate(-45 -6.2168 166.263)",
    fill: "#FFE10C"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.04492,
    cy: 152,
    r: 6.73132,
    transform: "rotate(-45 8.04492 152)",
    fill: "#FFE10C"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3086,
    cy: 137.737,
    r: 6.73132,
    transform: "rotate(-45 22.3086 137.737)",
    fill: "#FFE10C"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5703,
    cy: 123.475,
    r: 6.73132,
    transform: "rotate(-45 36.5703 123.475)",
    fill: "#FFE10C"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.834,
    cy: 109.212,
    r: 6.73132,
    transform: "rotate(-45 50.834 109.212)",
    fill: "#FFE10C"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.0957,
    cy: 94.9492,
    r: 6.73132,
    transform: "rotate(-45 65.0957 94.9492)",
    fill: "#FFE10C"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.3066,
    cy: 166.263,
    r: 6.73132,
    transform: "rotate(-45 22.3066 166.263)",
    fill: "#FFE10C"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5703,
    cy: 152,
    r: 6.73132,
    transform: "rotate(-45 36.5703 152)",
    fill: "#FFE10C"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.832,
    cy: 137.737,
    r: 6.73132,
    transform: "rotate(-45 50.832 137.737)",
    fill: "#FFE10C"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.0957,
    cy: 123.475,
    r: 6.73132,
    transform: "rotate(-45 65.0957 123.475)",
    fill: "#FFE10C"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.3574,
    cy: 109.212,
    r: 6.73132,
    transform: "rotate(-45 79.3574 109.212)",
    fill: "#FFE10C"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.832,
    cy: 166.263,
    r: 6.73132,
    transform: "rotate(-45 50.832 166.263)",
    fill: "#FFE10C"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 65.0938,
    cy: 152,
    r: 6.73132,
    transform: "rotate(-45 65.0938 152)",
    fill: "#FFE10C"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.3574,
    cy: 137.737,
    r: 6.73132,
    transform: "rotate(-45 79.3574 137.737)",
    fill: "#FFE10C"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.6191,
    cy: 123.475,
    r: 6.73132,
    transform: "rotate(-45 93.6191 123.475)",
    fill: "#FFE10C"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 79.3574,
    cy: 166.263,
    r: 6.73132,
    transform: "rotate(-45 79.3574 166.263)",
    fill: "#FFE10C"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.6211,
    cy: 152,
    r: 6.73132,
    transform: "rotate(-45 93.6211 152)",
    fill: "#FFE10C"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.883,
    cy: 137.737,
    r: 6.73132,
    transform: "rotate(-45 107.883 137.737)",
    fill: "#FFE10C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4365_883",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1187,
    y: -30,
    width: 279,
    height: 282
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1187.24,
    y: 89.0239,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 1187.24 89.0239)",
    fill: "#15A0DC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1200.25,
    y: 77.7329,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 1200.25 77.7329)",
    fill: "#15A0DC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1213.26,
    y: 66.4419,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 1213.26 66.4419)",
    fill: "#15A0DC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1226.28,
    y: 55.1509,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 1226.28 55.1509)",
    fill: "#15A0DC"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1239.29,
    y: 43.8599,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 1239.29 43.8599)",
    fill: "#15A0DC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1252.3,
    y: 32.5688,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 1252.3 32.5688)",
    fill: "#15A0DC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1265.32,
    y: 21.2778,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 1265.32 21.2778)",
    fill: "#15A0DC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1278.33,
    y: 9.98682,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 1278.33 9.98682)",
    fill: "#15A0DC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1291.35,
    y: -1.3042,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 1291.35 -1.3042)",
    fill: "#15A0DC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1304.36,
    y: -12.5952,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 1304.36 -12.5952)",
    fill: "#15A0DC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1317.37,
    y: -23.8857,
    width: 8.61452,
    height: 215.363,
    transform: "rotate(-40.9459 1317.37 -23.8857)",
    fill: "#15A0DC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4365_883)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1322.92,
    cy: 107.223,
    r: 87.222,
    fill: "#34B5EC"
  }))), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 1374.67,
    cy: 129.993,
    r: 87.222,
    fill: "#34B5EC"
  })))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_959_271",
    x1: 240.5,
    y1: -236,
    x2: 1616,
    y2: 408.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15A0DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522513,
    stopColor: "#199BD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02628C"
  }))), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: -292,
    r: 400,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderElipse);
export default __webpack_public_path__ + "static/media/header-elipse.a5e838d8842bace4594a3a8dd32344a6.svg";
export { ForwardRef as ReactComponent };